import * as apiUtils from '../apiCallerProxy';
import { searchApiFactory } from './searchApiFactory';

export * from './hooks';
export default searchApiFactory(apiUtils);
